import React from 'react';
import { Row, Col, Space } from 'antd';
import { I18n } from '@aws-amplify/core';
import { BaseModal } from './shared/BaseModal';
import * as S from './styles';

interface HandleNotificationsModalProps {
	visible?: boolean;
	loading?: boolean;
	onConfirm: () => void;
	onCancel: () => void;
	customMessage?: string;
	isEnabled?: boolean;
}

export function HandleNotificationsModal({
	visible = false,
	loading = false,
	customMessage = '',
	onConfirm,
	onCancel
}: Readonly<HandleNotificationsModalProps>) {
	return (
		<BaseModal visible={visible} onCancel={onCancel} footer={false}>
			<Space direction="vertical" size={24} align="center" style={{ width: '100%' }}>
				<S.BellOutlinedBig />
				<S.CustomMessage>{customMessage}</S.CustomMessage>
				<Row justify="center" gutter={16}>
					<Col>
						<S.CancelButton key="cancel" onClick={onCancel} disabled={loading}>
							{I18n.get('No')}
						</S.CancelButton>
					</Col>
					<Col>
						<S.PrimaryButton type="primary" onClick={onConfirm} loading={loading}>
							{I18n.get('Yes')}
						</S.PrimaryButton>
					</Col>
				</Row>
			</Space>
		</BaseModal>
	);
}
